const Footer = () => {
    return (
        <footer>
            <p>
                Created by Courtney Gibson 🍄 at <a href="https://junocollege.com/"> Juno College 2022</a>
            </p>
        </footer>
    )
}

export default Footer;